var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "rotate(90 15.5 15.5)",
    fill: "#8A49D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9917 17.3972C15.8312 17.4976 15.6505 17.5377 15.49 17.5377C15.3294 17.5377 15.1488 17.4976 14.9882 17.3972L7 12.52V19.0029C7 20.3878 8.12397 21.5118 9.50885 21.5118H21.4911C22.876 21.5118 24 20.3878 24 19.0029V12.52L15.9917 17.3972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4909 8.98779H9.50865C8.32447 8.98779 7.32093 9.83077 7.08008 10.9547L15.5098 16.0929L23.9195 10.9547C23.6787 9.83077 22.6751 8.98779 21.4909 8.98779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailContact);
export default __webpack_public_path__ + "static/media/Mail-Contact.b44ea85c7ea3b45c90e8ef70d624c5dd.svg";
export { ForwardRef as ReactComponent };